import * as React from 'react';
// import { createFragmentContainer, graphql, RelayProp } from 'react-relay';
import Dialog from 'material-ui/Dialog';
import { Flex, Box } from 'grid-styled';
import FlatButton from 'material-ui/FlatButton';
import { connect } from 'kea';
// import CartUpdateEventIdMutation from '../../../mutationsModern/Cart/CartUpdateEventIdMutation';
// import CartPromoCodeDeleteMutation from '../../../mutationsModern/Cart/CartPromoCodeDeleteMutation';

import { mediumButtonPurple } from '../../../styles/button.style';
import {
  toolBarGrey,
  bodyStyle,
  bodyStyleMobile,
  actionsContainerStyle,
  dialogStyle,
  customContentStyle,
  customContentStyleMobile,
} from '../../../styles/global.style';
import { mobile } from '../../../utils/deviceWidths';
import MobileToolBar from '../../../marketplace/components/__needsConversion/MobileToolBar';
import EventClosedDialogLogic from '../_kea/EventClosedDialogLogic';

interface EventClosedDialogProps {
  containerWidth: number;
  eventClosedDialogIsOpen: boolean;
  actions: { closeEventClosedDialog: () => void };
  environment: unknown;
}

const DialogButtons = (onSubmit: () => void) => [
  <Flex
    key="EventClosedDialog"
    align="center"
    style={{ padding: 10 }}
    justify="space-between"
  >
    <Box />
    <Box>
      <FlatButton
        {...mediumButtonPurple}
        label="CLOSE"
        className="savePaymentButton"
        onClick={onSubmit}
      />
    </Box>
  </Flex>,
];

@connect({
  actions: [
    EventClosedDialogLogic,
    ['closeEventClosedDialog', 'openEventClosedDialog'],
  ],
  props: [EventClosedDialogLogic, ['eventClosedDialogIsOpen']],
})
class EventClosedDialog extends React.Component<EventClosedDialogProps, {}> {
  UNSAFE_componentWillReceiveProps(nextProps: EventClosedDialogProps) {
    if (
      !this.props.eventClosedDialogIsOpen &&
      nextProps.eventClosedDialogIsOpen
    ) {
      // const { environment } = this.props;
      // CartPromoCodeDeleteMutation.commit({
      //   environment,
      //   promoCode: 'CASE4CAUSE',
      //   onCompleted: (response: {}, error: {}) => {
      //     console.log('response deleting promo', response);
      //   },
      //   onError: (transaction: {}) => {
      //     console.log('error for deleting promo', transaction);
      //   },
      // });
    }
  }

  closeEventClosedDialog = () => this.props.actions.closeEventClosedDialog();

  render() {
    const { containerWidth, eventClosedDialogIsOpen } = this.props;
    return (
      <Dialog
        open={eventClosedDialogIsOpen}
        modal={false}
        actions={DialogButtons(this.closeEventClosedDialog)}
        autoScrollBodyContent
        className="dialog-root"
        bodyClassName="dialog-body"
        title={
          <MobileToolBar
            style={toolBarGrey}
            title="EVENT ENDED"
            handleClose={this.closeEventClosedDialog}
          />
        }
        actionsContainerStyle={actionsContainerStyle}
        contentStyle={
          containerWidth <= mobile
            ? customContentStyleMobile
            : customContentStyle
        }
        bodyStyle={containerWidth <= mobile ? bodyStyleMobile : bodyStyle}
        style={dialogStyle}
      >
        <div>
          The event has ended. You'll have to join another event to get the
          discounts.
        </div>
      </Dialog>
    );
  }
}

export default EventClosedDialog;
